/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../../config/settings.config.json';

export interface ISettingsMethods extends IPluginMethodMap {
  getSettingsProps(args: any): Promise<any>;
}

export class SettingsService implements IAgentPlugin {
  readonly methods: ISettingsMethods;

  constructor() {
    this.methods = {
      getSettingsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return { ...(config || {}) };
  }
}
